import EditArtistSidePane from "./EditArtistSidePane";

export default EditArtistSidePane;
